import Script from 'next/script';
import { useRouter } from 'next/router';
import { Fragment } from 'react';
import { Box, Link, ResponsiveSection, Text } from '@stitch-fix/mode-react';
import styles from './style.module.scss';
import type { GreenhouseDepartment } from '../../utils/requests/greenhouse/requests';
const getDepartmentDescription = (departmentName: string) => {
  switch (departmentName) {
    case 'engineering':
      return <Text setting="body-small">
          To learn more about our Engineering team, please visit{' '}
          <Link href="https://multithreaded.stitchfix.com/engineering/">
            MultiThreaded - Engineering at Stitch Fix.
          </Link>
        </Text>;
    case 'algorithms':
      return <Text setting="body-small">
          To learn more about our Algorithms team, please visit{' '}
          <Link href="https://multithreaded.stitchfix.com/algorithms/">
            MultiThreaded - Algorithms at Stitch Fix.
          </Link>
        </Text>;
    default:
      return null;
  }
};
export type GreenhouseJobsListProps = {
  departments: GreenhouseDepartment[];
};
export const GreenhouseJobsList = ({
  departments
}: GreenhouseJobsListProps) => {
  const router = useRouter();
  const showGreenhouseApp = router.query.gh_jid !== undefined;
  return <ResponsiveSection width="xlarge" gutter="standard">
      <Box id="grnhse_app_wrapper">
        {showGreenhouseApp ? <div id="grnhse_app" /> : <>
            {departments.map(dept => {
          if (dept.jobs.length < 1) {
            return null;
          }
          const departmentName = dept.name.toLowerCase();
          return <Fragment key={dept.name}>
                  <Box bgColor="gray-95" p={2}>
                    <Text as="h2" setting="title-xsmall" spacingBottom>
                      {dept.name}
                    </Text>
                    {getDepartmentDescription(departmentName)}
                  </Box>
                  <ul className={styles.jobs}>
                    {dept.jobs.map(job => {
                let jobPostingURL = job.absolute_url;

                // Override the job posting url for styling community job listings
                if (dept.name.toLowerCase() === 'styling' && job.title.toLowerCase().includes('community')) {
                  jobPostingURL = 'https://www.stitchfix.com/careers/styling';
                }
                return <li className={styles['job-info']} key={jobPostingURL}>
                          <Text setting="body-small">
                            <Link href={jobPostingURL}>{job.title}</Link>
                          </Text>
                          <Box style={{
                    minWidth: '18rem'
                  }}>
                            <Text setting="body-small">
                              {job.location.name}
                            </Text>
                          </Box>
                        </li>;
              })}
                  </ul>
                </Fragment>;
        })}
          </>}
        <Script src="https://boards.greenhouse.io/embed/job_board/js?for=stitchfix" onLoad={() => {
        if (showGreenhouseApp) {
          Grnhse.Iframe.load();
        }
      }} />
      </Box>
    </ResponsiveSection>;
};